export const PRICING = {
  TIER_1_MAX: 100,
  TIER_1_PRICE: 149.99,
  GROWING_MAX: 499,
  GROWING_PER_CLIENT: 0.75,
  CAP_MIN: 500,
  CAP_PRICE: 599.99,
};

/**
 * Build a progressive tier breakdown for display.
 * Decomposes total member count into per-tier rows.
 */
export const buildTierBreakdown = (memberCount) => {
  if (!memberCount || memberCount <= 0) return [];

  const rows = [];

  if (memberCount >= PRICING.CAP_MIN) {
    rows.push({
      label: "Elite (Capped)",
      range: `${PRICING.CAP_MIN}+ members`,
      members: memberCount,
      rule: "Flat Fee (Elite)",
      ruleDetail: null,
      price: PRICING.CAP_PRICE,
    });
    return rows;
  }

  // Starter: first 100 members
  const starterMembers = Math.min(memberCount, PRICING.TIER_1_MAX);
  rows.push({
    label: "Starter Base Fee",
    range: "1-100 members",
    members: starterMembers,
    rule: "Flat Fee",
    ruleDetail: null,
    price: PRICING.TIER_1_PRICE,
  });

  // Growing: members 101-499
  if (memberCount > PRICING.TIER_1_MAX) {
    const growingMembers =
      Math.min(memberCount, PRICING.GROWING_MAX) - PRICING.TIER_1_MAX;
    const growingPrice = growingMembers * PRICING.GROWING_PER_CLIENT;
    rows.push({
      label: "Growing",
      range: "101-499 members",
      members: growingMembers,
      rule: `$${PRICING.GROWING_PER_CLIENT.toFixed(2)} × ${growingMembers}`,
      ruleDetail: `$${PRICING.TIER_1_PRICE} + ($${PRICING.GROWING_PER_CLIENT.toFixed(2)} × overage beyond 100)`,
      price: growingPrice,
    });
  }

  return rows;
};
